var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJavaScript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_103_753)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_103_753)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_103_753)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H50V50H0V0Z",
    fill: "#F7DF1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5873 39.0627C34.5945 40.7072 35.9048 41.9159 38.2222 41.9159C40.1691 41.9159 41.4127 40.9429 41.4127 39.5984C41.4127 37.9873 40.1349 37.4167 37.9921 36.4794L36.8175 35.9754C33.427 34.531 31.1746 32.7214 31.1746 28.896C31.1746 25.3722 33.8595 22.6897 38.0556 22.6897C41.0429 22.6897 43.1905 23.7294 44.7381 26.4516L41.0794 28.8008C40.2738 27.3564 39.4048 26.7873 38.0556 26.7873C36.6794 26.7873 35.8071 27.6603 35.8071 28.8008C35.8071 30.2103 36.6802 30.781 38.696 31.654L39.8706 32.1572C43.8627 33.8691 46.1167 35.6143 46.1167 39.5381C46.1167 43.7683 42.7937 46.0857 38.331 46.0857C33.9675 46.0857 31.1484 44.0064 29.7691 41.281L33.5873 39.0627ZM16.9897 39.4699C17.7278 40.7794 18.3992 41.8865 20.0135 41.8865C21.5571 41.8865 22.531 41.2826 22.531 38.9341V22.9579H27.2294V38.9976C27.2294 43.8627 24.377 46.077 20.2135 46.077C16.4516 46.077 14.273 44.1302 13.1651 41.7853L16.9897 39.4699Z",
    fill: "black"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_103_753"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_103_753"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_103_753"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavaScript);
export default __webpack_public_path__ + "static/media/javaScript.05971d211aa563c56614fd918ef504d1.svg";
export { ForwardRef as ReactComponent };